import React, { useEffect, useState } from 'react';
import styled, { withTheme } from 'styled-components';
import Slider from "react-slick";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import "../../../../node_modules/slick-carousel/slick/slick.css";
import "../../../../node_modules/slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
// import config from 'src/config/config';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from 'src/util/utilModel';
import { theme } from 'styled-tools';
import { withAppContext } from 'src/store/initAppContext';
// import ImgData from './bannerData';
// import { useQuery } from '@apollo/client';
// import { GET_BANNERS } from 'src/graphql/events';
// import util from 'src/util/util';
import { SRTM } from 'src/util/sportradarEvent';
//import bannerData from 'src/static/banner_data_desktop.json';
import config from 'src/config/config';
import { CRMDesktopBannerClick } from 'src/util/crmUtil';

type BannerProps = {
    position: number;
    engUrl: string;
    hindiUrl: string;
    pathname: string;
    altname: string;
    gtmID: string;
    external?:boolean;
}

function BannerSliderNew(props: any) {

    const language = cookieUtil.get(ECookieName.COOKIE_LANG);
    const { app: { brandId } } = props;

    //Extra Code to Banner Data
    const [bannerDATA, setBannerDATA] = useState<BannerProps[]>([])
   
    useEffect(() => {
        try {
            const gqlURL = config.gqlHost;
            const fileEnv = gqlURL.includes('bbb365.link') ? 'dev' : 'prod';
            fetch(`https://pixel.raksahb.com/banner-data/${fileEnv}/banner_data_desktop.json`,{cache: "no-cache"})
                .then(data => data.json())
                .then(data => {
                    const _data = data[brandId] || [];
                    const _shortedData = [..._data].sort((a, b) => a.position - b.position);
                    setBannerDATA(_shortedData);
                })
                .catch(error => console.error('Error in Image Data', error))
        } catch (error) {
            console.error('Error in image Data', error)
        }
        //SRTM 
        SRTM.init(brandId);
    }, []);



    // const { loading, error, data } = useQuery(GET_BANNERS,
    //     {
    //         variables: {
    //             input: {
    //                 brandId: brandId,
    //                 deviceType: 1,
    //             },
    //         },
    //     });


    // if (loading) {
    //     return <div>Loading...</div>;
    // }

    // if (error) {
    //     console.log('Something went wrong', error);
    //     return null;
    // }

    // const bannerDATA = util.getValue(data, ['menu', 'baners', 'data', 'web'], []);
    // const _data = [...bannerDATA].sort((a, b) => a.position - b.position);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        pauseOnHover: true
    };

    return (
        <ImageBannerWrapper>

            {bannerDATA && bannerDATA.length > 0 ? (
                <Slider {...settings}>
                    {bannerDATA.map((img, index) => {
                        const imgName = img.altname;
                        const _imgsrc = language === 'hindi-ind' ? img.hindiUrl : img.engUrl;

                        //adding extra code to fix 404
                        // const isExternal = img.external || true;
                        // Set `isExternal` to true only if `pathname` is "Wheel-of-fortune/"
                        const isExternal = img.gtmID === "fortune";
                        // console.log(isExternal, 'isExternal');
                        return (
                            <div key={index}>
                               {!isExternal ? (<Link className="banner_img" to={img.pathname} onClick={() => CRMDesktopBannerClick(brandId, _imgsrc)}>
                                    <LazyLoadImage
                                        src={`${config.commonImgS3Host}${_imgsrc}`}
                                        alt={imgName}
                                        effect="none"
                                        height="100%"
                                        width="100%"
                                        placeholder={<PlaceholderImage />}
                                    />
                                </Link>) :(
                                    <a className="banner_img" target='_blank' 
                                    href={img.pathname} 
                                    onClick={() => CRMDesktopBannerClick(brandId, _imgsrc)}>
                                    <LazyLoadImage
                                        src={`${config.commonImgS3Host}${_imgsrc}`}
                                        alt={imgName}
                                        effect="none"
                                        height="100%"
                                        width="100%"
                                        placeholder={<PlaceholderImage />}
                                    />
                                </a>
                                )}
                            </div>
                        );
                    })}
                </Slider>
            ) : null}
        </ImageBannerWrapper>
    )
}


export default withAppContext(withTheme(BannerSliderNew));

const ImageBannerWrapper = styled.div`
    width: 100%;
    position: relative;
    max-height: 599px;
    .banner_img {
        img {
            width: 100%;
            height: 100%;
        }
    }

    .slick-dots {
        display: flex!important;
        align-items: center;
        justify-content: center;
        padding: 10px;
        bottom: 4px;
        background-color: ${theme('palette.BannerDotsBg')};

        li {
            margin: 0px 1px;
        }
        li button:before {
            font-size: 13px;
            color: ${theme('palette.BannerDotsColor')};
        }
        li.slick-active button:before {
            opacity: .75;
            color: ${theme('palette.BannerDotsActiveColor')};
        }
    }
`;